import { render } from "./Vinculo.vue?vue&type=template&id=9d5ba7c2&scoped=true"
import script from "./Vinculo.vue?vue&type=script&lang=js"
export * from "./Vinculo.vue?vue&type=script&lang=js"

import "./Vinculo.vue?vue&type=style&index=0&id=9d5ba7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5ba7c2"]])

export default __exports__